import React from 'react'
import styles from './current-skeleton.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'
import { Table, TableRow, HeadCell } from 'pobble-components/dist/table'
import CurrentSkeletonEntry from './current-skeleton-entry/current-skeleton-entry'

const CurrentSkeleton = ({ classes }) => (
  <div className={classes.container}>
    <Table className={classes.table}>
      <thead>
        <TableRow>
          <HeadCell className={classes.allCell}>
            <Bone className={classes.all} />
          </HeadCell>
          <HeadCell className={classes.receivedCell}>
            <Bone className={classes.received} />
          </HeadCell>
          <HeadCell className={classes.receivedCell}>
            <Bone className={classes.received} />
          </HeadCell>
          <HeadCell className={classes.titleCell}>
            <Bone className={classes.title} />
          </HeadCell>
          <HeadCell className={classes.conclusionCell}>
            <Bone className={classes.conclusion} />
          </HeadCell>
          <HeadCell className={classes.contextCell}>
            <Bone className={classes.bulkAction} />
          </HeadCell>
        </TableRow>
      </thead>
      <tbody>
        <CurrentSkeletonEntry titleWidth={100} />
        <CurrentSkeletonEntry titleWidth={60} />
        <CurrentSkeletonEntry titleWidth={90} />
        <CurrentSkeletonEntry titleWidth={70} />
      </tbody>
    </Table>
  </div>
)

export default injectSheet(styles)(CurrentSkeleton)
